import React, { useEffect, useMemo } from 'react';
import { AsideMenu } from '../components/AsideMenu';
import { useCommon } from '../../../contexts/CommonContext';
import { useTenant } from '../../../contexts/TenantContext';
import { useBillingConsumptionContext } from '../../../contexts/Billing/BillingConsumptionContext';
import { useBillingPlanUsageContext } from '../../../contexts/Billing/BillingPlanUsageContext';
import { useContentLocalizer } from '../../../hooks/useContentLocalizer';
import AiTokenConsumptionContext from '../../../contexts/Billing/AiTokenConsumptionContext';
import { AiTokenConsumptionDataContextProvider } from '../../../contexts/Billing/AiTokenConsumptionDataContext';
import AiTokenConsumptionSummary from './components/AiTokenConsumptionSummary';
import { localization } from './localization';
import {
  action,
  origin,
  REPORT_AI_TOKEN_CONSUMPTION_OPEN,
  REPORT_AI_TOKEN_CONSUMPTION_CLOSED,
} from '../../../shared/SegmentEvents';
import { usePageTracking } from '../hooks/usePageTracking';

const AiTokenConsumption: React.FC = () => {
  const { setHeaderContent, common: { loggedUser } } = useCommon();
  const { tenant } = useTenant();
  const { dateToSearch, setDateToSearch, periodOptions, currentMonth } = useBillingConsumptionContext();
  const { planStatus, getPlanStatus } = useBillingPlanUsageContext();
  const content = useContentLocalizer(localization);

  const PAGE_NAME = 'Detalhamento das métricas de AI Token';
  usePageTracking(PAGE_NAME, REPORT_AI_TOKEN_CONSUMPTION_OPEN, REPORT_AI_TOKEN_CONSUMPTION_CLOSED, tenant, loggedUser, true);

  useEffect(() => {
    setHeaderContent({
      redirect: '/data-consumption',
      text: content.header,
    });

    return () => setHeaderContent({ redirect: null });
  }, [content.header, setHeaderContent]);

  const trackingProps = useMemo(
    () => ({
      date: dateToSearch,
      planStatus: planStatus.current,
      origin: origin.AITOKEN,
      action: action.SELECT,
    }),
    [dateToSearch, planStatus.current],
  );

  const contextProps = useMemo(
    () => ({ content, dateToSearch, setDateToSearch, periodOptions, currentMonth, tenant, loggedUser, trackingProps, getPlanStatus }),
    [content, dateToSearch, setDateToSearch, periodOptions, currentMonth, tenant, loggedUser, trackingProps, getPlanStatus],
  );

  return (
    <AiTokenConsumptionContext.Provider value={contextProps}>
      <AiTokenConsumptionDataContextProvider tenant={tenant}>
        <AsideMenu>
          <AiTokenConsumptionSummary />
        </AsideMenu>
      </AiTokenConsumptionDataContextProvider>
    </AiTokenConsumptionContext.Provider>
  );
};

export default AiTokenConsumption;
